function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconlogout = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.88,
    height: 11.799,
    viewBox: "0 0 11.88 11.799",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.708 0A.712.712 0 0 0 0 .708v10.383a.712.712 0 0 0 .708.708h8.024a.712.712 0 0 0 .708-.708V9.2l-.472.472v1.416a.233.233 0 0 1-.236.236H.708a.233.233 0 0 1-.236-.236V.708A.232.232 0 0 1 .708.472h8.024a.233.233 0 0 1 .236.236v1.416l.472.472V.708A.712.712 0 0 0 8.732 0zm8.223 3.09a.234.234 0 0 0-.184.166.237.237 0 0 0 .066.24l2.168 2.168H3.99a.236.236 0 1 0 .022.472h6.969L8.813 8.3a.236.236 0 1 0 .332.332l2.574-2.566.162-.17-.162-.17-2.575-2.562a.237.237 0 0 0-.192-.074z",
    style: {
      fill: "#5a5a5a"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconlogout);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.logout.6320db41d2d6c1f9d2e4fec9dcdf12ea.svg";